import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@kueski-dev/kueski-design-system';

const ForwardIcon = ({ handleOnClick, color, disabled }) => (
  <Icon
    fillColor={color === 'secondary' ? '#008BFF' : 'var(--k-ds-color-grey-700)'}
    height={10}
    name="CaretRight"
    onClick={handleOnClick}
    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    width={6}
  />
);

ForwardIcon.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary']),
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func,
};

ForwardIcon.defaultProps = {
  color: 'primary',
  disabled: false,
  handleOnClick: null,
};

export default ForwardIcon;
